import React, { useState, useEffect } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { Link, withRouter } from "react-router-dom";
import {
  CircularProgress,
  makeStyles,
  Button,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { BsPersonFill } from "react-icons/bs";
import { AiFillLock } from "react-icons/ai";
import {
  staffSignin,
  authentication,
  isAuth,
} from "../../actions/auth";
import logo from "../../assets/images/logo.png";
import Notify from "../customHelpers/Notify";
import Notification from "../customHelpers/Notification";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    backgroundColor: "#f3f4f6", // Gray-100
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),
  },
  card: {
    maxWidth: 400,
    width: "100%",
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1.5),
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(3),
  },
  logo: {
    maxHeight: 80,
  },
  title: {
    fontWeight: 600,
    color: "rgb(20,61,89)",
    textAlign: "center",
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    textAlign: "center",
    color: "#6b7280",
    marginBottom: theme.spacing(4),
  },
  submitButton: {
    marginTop: theme.spacing(3),
    backgroundColor: "rgba(244,151,3,.8)",
    color: "#fff",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "rgba(244,151,3, 1)",
    },
  },
  links: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  linkText: {
    color: "rgb(20,61,89)",
    textDecoration: "none",
    fontSize: "0.875rem",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  errorAlert: {
    marginBottom: theme.spacing(2),
  },
}));

const SigninComponent = ({ history }) => {
  const classes = useStyles();
  const { NotifyMessage, notify, setNotify } = Notify();
  const [values, setValues] = useState({
    username: "",
    password: "",
    error: "",
    loading: false,
  });

  const { username, password, error, loading } = values;

  useEffect(() => {
    if (isAuth()) {
      history.push("/admin");
    }
  }, [history]);

  const handleChange = (name) => (e) => {
    setValues({ ...values, error: "", [name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setValues({ ...values, loading: true, error: "" });
    staffSignin({ username, password }).then((data) => {
      if (data.err) {
        setValues({ ...values, error: data.err, loading: false });
        NotifyMessage({ message: data.err, type: "error" });
      } else {
        if (data.user && data.token) {
          authentication(data, () => {
            history.push(`/admin`);
          });
        } else {
          setValues({ ...values, error: "Authentication failed", loading: false });
        }
      }
    });
  };

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <div className={classes.logoContainer}>
          <img src={logo} className={classes.logo} alt="Logo" />
        </div>
        <CardContent>
          <Typography variant="h5" className={classes.title}>
            Sign In
          </Typography>
          <Typography variant="body2" className={classes.subtitle}>
            Welcome back to Info Ethiopia Dashboard
          </Typography>

          {error && (
            <Alert severity="error" className={classes.errorAlert}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Email or Username"
              name="username"
              autoComplete="username"
              value={username}
              onChange={handleChange("username")}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <BsPersonFill color="action" />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Password"
              name="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={handleChange("password")}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiFillLock color="action" />
                  </InputAdornment>
                ),
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              className={classes.submitButton}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "Login"}
            </Button>
            <div className={classes.links}>
              <Link to="/staff/forgot-password" className={classes.linkText}>
                Forgot Password?
              </Link>
            </div>
          </form>
        </CardContent>
      </Card>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  );
};

export default withRouter(SigninComponent);
